"use strict";
/**
 * Free Pattern Warehouse Shared Types
 *
 * Authoritative TypeScript definitions for all data structures
 * Used by both frontend and backend to ensure consistency
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedBatchGet = exports.typedQuery = exports.typedGet = exports.isProfileModeration = exports.isCraftRoomModeration = exports.isCommentModeration = exports.isMaterialContribution = exports.isReviewModeration = exports.isPatternModeration = exports.MaterialType = void 0;
// Shared enums (consolidated string literal unions)
__exportStar(require("./enums"), exports);
// Generic utility types
__exportStar(require("./generic"), exports);
// Database record types (DynamoDB structures)
__exportStar(require("./database"), exports);
__exportStar(require("./database/craft-room"), exports);
var craft_room_1 = require("./database/craft-room");
Object.defineProperty(exports, "MaterialType", { enumerable: true, get: function () { return craft_room_1.MaterialType; } });
__exportStar(require("./database/public-material"), exports);
__exportStar(require("./database/visibility"), exports);
__exportStar(require("./database/material-categories"), exports);
__exportStar(require("./database/material-attribute-model"), exports);
// Typed_Test_Fixtures — exhaustive per-(category, subcategory) attribute fixtures.
// Re-exported so lambda/website conformance tests can import the registry.
__exportStar(require("./database/__fixtures__/material-attributes.fixtures"), exports);
__exportStar(require("./database/migration-progress"), exports);
__exportStar(require("./database/material-propagation"), exports);
__exportStar(require("./database/material-offers"), exports);
var moderation_unified_1 = require("./database/moderation-unified");
Object.defineProperty(exports, "isPatternModeration", { enumerable: true, get: function () { return moderation_unified_1.isPatternModeration; } });
Object.defineProperty(exports, "isReviewModeration", { enumerable: true, get: function () { return moderation_unified_1.isReviewModeration; } });
Object.defineProperty(exports, "isMaterialContribution", { enumerable: true, get: function () { return moderation_unified_1.isMaterialContribution; } });
Object.defineProperty(exports, "isCommentModeration", { enumerable: true, get: function () { return moderation_unified_1.isCommentModeration; } });
Object.defineProperty(exports, "isCraftRoomModeration", { enumerable: true, get: function () { return moderation_unified_1.isCraftRoomModeration; } });
Object.defineProperty(exports, "isProfileModeration", { enumerable: true, get: function () { return moderation_unified_1.isProfileModeration; } });
// API request/response types
__exportStar(require("./api"), exports);
__exportStar(require("./api/craft-room"), exports);
__exportStar(require("./api/craft-projects"), exports);
__exportStar(require("./api/brand"), exports);
// Notification API types
__exportStar(require("./api/notification"), exports);
// Domain/business logic types
__exportStar(require("./domain"), exports);
// Rating calculation utilities
__exportStar(require("./utils/ratingUtils"), exports);
// Default column configurations
__exportStar(require("./utils/defaultColumns"), exports);
// Error handling utilities
__exportStar(require("./utils/error-types"), exports);
// Typed DynamoDB query helpers
// Note: Runtime functions are re-exported for backend consumers.
// Frontend bundlers should tree-shake these since they're not imported by frontend code.
var typed_dynamo_1 = require("./utils/typed-dynamo");
Object.defineProperty(exports, "typedGet", { enumerable: true, get: function () { return typed_dynamo_1.typedGet; } });
Object.defineProperty(exports, "typedQuery", { enumerable: true, get: function () { return typed_dynamo_1.typedQuery; } });
Object.defineProperty(exports, "typedBatchGet", { enumerable: true, get: function () { return typed_dynamo_1.typedBatchGet; } });
// OpenSearch document types
__exportStar(require("./opensearch/material"), exports);
__exportStar(require("./opensearch/material-in-search"), exports);
__exportStar(require("./opensearch/pattern"), exports);
__exportStar(require("./opensearch/project"), exports);
__exportStar(require("./opensearch/index-definitions"), exports);
// Messaging envelope types (SQS follow-activity)
__exportStar(require("./messaging/follow-activity"), exports);
